document.addEventListener('DOMContentLoaded', () => {
  function handleClick(link) {
    const targetSelector = link.getAttribute('href')
    const targetElement = document.querySelector(targetSelector)
    if (targetElement) {
      const offset = document.querySelector('.header-wrapper[is-sticky]')?.offsetHeight || 0
      window.scrollTo({
        top: targetElement.offsetTop - offset,
        behavior: 'smooth',
      })
    }
  }

  document.querySelectorAll('.js-category-link').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault()
      handleClick(link)
    })
  })
})
